import React from "react";

const SEOSettingsModal = ({ seoSetting, onClose }) => {
  if (!seoSetting) return null;

  const formatDate = (timestamp) => {
    if (!timestamp) return "N/A";
    return new Date(timestamp.toDate()).toLocaleString();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>SEO Settings Details</h3>
          <button className="btn-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="modal-body">
          <div className="row">
            <div className="col-md-6">
              <div className="detail-section">
                <h4>Basic Information</h4>
                <div className="detail-item">
                  <label>Page Path:</label>
                  <span className="value">{seoSetting.pagePath}</span>
                </div>
                <div className="detail-item">
                  <label>Status:</label>
                  <span
                    className={`badge ${
                      seoSetting.isActive ? "bg-success" : "bg-secondary"
                    }`}
                  >
                    {seoSetting.isActive ? "Active" : "Inactive"}
                  </span>
                </div>
                <div className="detail-item">
                  <label>Created:</label>
                  <span className="value">
                    {formatDate(seoSetting.createdAt)}
                  </span>
                </div>
                <div className="detail-item">
                  <label>Last Updated:</label>
                  <span className="value">
                    {formatDate(seoSetting.updatedAt)}
                  </span>
                </div>
              </div>

              <div className="detail-section">
                <h4>Basic SEO</h4>
                <div className="detail-item">
                  <label>Title:</label>
                  <span className="value">{seoSetting.title}</span>
                </div>
                <div className="detail-item">
                  <label>Description:</label>
                  <span className="value">{seoSetting.description}</span>
                </div>
                <div className="detail-item">
                  <label>Keywords:</label>
                  <span className="value">{seoSetting.keywords}</span>
                </div>
                <div className="detail-item">
                  <label>Author:</label>
                  <span className="value">{seoSetting.author || "N/A"}</span>
                </div>
                <div className="detail-item">
                  <label>Robots:</label>
                  <span className="value">{seoSetting.robots}</span>
                </div>
                <div className="detail-item">
                  <label>Canonical URL:</label>
                  <span className="value">
                    {seoSetting.canonicalUrl || "N/A"}
                  </span>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="detail-section">
                <h4>Open Graph (Facebook)</h4>
                <div className="detail-item">
                  <label>OG Title:</label>
                  <span className="value">{seoSetting.ogTitle || "N/A"}</span>
                </div>
                <div className="detail-item">
                  <label>OG Description:</label>
                  <span className="value">
                    {seoSetting.ogDescription || "N/A"}
                  </span>
                </div>
                <div className="detail-item">
                  <label>OG Image:</label>
                  <span className="value">
                    {seoSetting.ogImage ? (
                      <a
                        href={seoSetting.ogImage}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {seoSetting.ogImage}
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </span>
                </div>
                <div className="detail-item">
                  <label>OG Type:</label>
                  <span className="value">{seoSetting.ogType}</span>
                </div>
                <div className="detail-item">
                  <label>OG URL:</label>
                  <span className="value">{seoSetting.ogUrl || "N/A"}</span>
                </div>
              </div>

              <div className="detail-section">
                <h4>Twitter Card</h4>
                <div className="detail-item">
                  <label>Card Type:</label>
                  <span className="value">{seoSetting.twitterCard}</span>
                </div>
                <div className="detail-item">
                  <label>Twitter Title:</label>
                  <span className="value">
                    {seoSetting.twitterTitle || "N/A"}
                  </span>
                </div>
                <div className="detail-item">
                  <label>Twitter Description:</label>
                  <span className="value">
                    {seoSetting.twitterDescription || "N/A"}
                  </span>
                </div>
                <div className="detail-item">
                  <label>Twitter Image:</label>
                  <span className="value">
                    {seoSetting.twitterImage ? (
                      <a
                        href={seoSetting.twitterImage}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {seoSetting.twitterImage}
                      </a>
                    ) : (
                      "N/A"
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="detail-section">
            <h4>Preview</h4>
            <div className="seo-preview">
              <div className="preview-item">
                <label>Google Search Result:</label>
                <div className="google-preview">
                  <div className="preview-title">{seoSetting.title}</div>
                  <div className="preview-url">
                    {seoSetting.canonicalUrl ||
                      `https://polani-2c215.web.app${seoSetting.pagePath}`}
                  </div>
                  <div className="preview-description">
                    {seoSetting.description}
                  </div>
                </div>
              </div>

              <div className="preview-item">
                <label>Facebook Share:</label>
                <div className="facebook-preview">
                  <div className="preview-image">
                    {seoSetting.ogImage ? (
                      <img src={seoSetting.ogImage} alt="OG Image" />
                    ) : (
                      <div className="no-image">No image</div>
                    )}
                  </div>
                  <div className="preview-content">
                    <div className="preview-title">
                      {seoSetting.ogTitle || seoSetting.title}
                    </div>
                    <div className="preview-description">
                      {seoSetting.ogDescription || seoSetting.description}
                    </div>
                    <div className="preview-url">
                      {seoSetting.ogUrl ||
                        `https://polani-2c215.web.app${seoSetting.pagePath}`}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default SEOSettingsModal;
